import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "../message/Message";
import UserService from "../../../services/AdminServices/UserService";

const initialState = {
  user: null,
  loading: false,
  error: null,
};

export const users = createAsyncThunk(
  "userdata/users",
  async ({ userId }, thunkAPI) => {
    try {
      const response = await UserService.users(userId);
      // thunkAPI.dispatch(
      //   setMessage({ message: response.data.message, type: "success" })
      // );
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message, type: "error" }));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const blockedUser = createAsyncThunk(
  "userdata/blockedUser",
  async ({ userId }, thunkAPI) => {
    debugger;
    try {
      const response = await UserService.blockedUser();
      // thunkAPI.dispatch(
      //   setMessage({ message: response.data.message, type: "success" })
      // );
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message, type: "error" }));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const changePassword = createAsyncThunk(
//   "userdata/changePassword",
//   async ({ userId }, thunkAPI) => {
//     debugger;
//     try {
//       const response = await UserService.users(userId);
//       thunkAPI.dispatch(
//         setMessage({ message: response.data.message, type: "success" })
//       );
//       return response.data.data;
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       thunkAPI.dispatch(setMessage({ message, type: "error" }));
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const profile = createAsyncThunk(
  "userdata/profile",
  async ({ userId, image }, thunkAPI) => {
    debugger;
    try {
      const response = await UserService.profile(userId, image);
      thunkAPI.dispatch(
        setMessage({ message: response.data.message, type: "success" })
      );
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message, type: "error" }));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const uploadGroupImage = createAsyncThunk(
  "userdata/profile",
  async ({ image }, thunkAPI) => {
    debugger;
    try {
      const response = await UserService.uploadImageGroup(image);
      thunkAPI.dispatch(
        setMessage({ message: response.data.message, type: "success" })
      );
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message, type: "error" }));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const unblockUser = createAsyncThunk(
  "userdata/unblockUser",
  async ({ id, userId }, thunkAPI) => {
    debugger;
    try {
      const response = await UserService.unblockUser(id, userId);
      thunkAPI.dispatch(
        setMessage({ message: response.data.message, type: "success" })
      );
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message, type: "error" }));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const UserSlice = createSlice({
  name: "userdata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(users.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(users.fulfilled, (state, action) => {
        debugger;
        state.loading = false;
        state.isLoggedIn = true;
        state.user = action.payload;
      })
      .addCase(users.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed";
      })
      // Case for 'profile' thunk
      .addCase(profile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(profile.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;

        if (state.user) {
          state.user.imageUrl = action.payload;
        } else {
          state.user = { imageUrl: action.payload };
        }
      })
      .addCase(profile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed";
      })
      .addCase(unblockUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(unblockUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
      })
      .addCase(unblockUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed";
      });
  },
});

const { reducer } = UserSlice;
export default reducer;
